
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")

export const getLot = async (lotId) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"lot/get/"+lotId, config)
      const lot = response.data?.data || null;
      return lot;
    } catch (error) {
      console.error("Error :", error);
      return null;
    }
  };

  

export const getList = async () => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"lot/list", config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const getListBySection= async (farmId) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"lot/list-by-section/"+farmId, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const getListByFarm = async (farmId) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"lot/list-by-farm/"+farmId, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const insert = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"lot/insert", data, config)
    return response;
  } catch (error) {
    console.error("Error :", error);
    return error.response;
  }
};



export const update = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"lot/update", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};




export const updateCenter = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"lot/update-center", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};


export const updateLinePalm = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"lot/update-line-palm", data, config)
    const responseData = response.data || null;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};


export const getPalmsLot = async (lotId) => {
  const params = {lotId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "lot/palms-lot", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};



export const deleteLot = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"lot/delete-lot", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};

export const renameLinePalm = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"palm/rename", data, config)
    const responseData = response.data || null;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};



  export default{
    getLot,
    getList,
    insert,
    getListByFarm,
    update,
    getListBySection,
    updateCenter,
    getPalmsLot,
    updateLinePalm,
    deleteLot,
    renameLinePalm
  }

